const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const supportApi = {
  // Get all tickets with filters and pagination
  getTickets: async (filters = {}, token) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(filters).forEach(key => {
      if (filters[key]) {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await fetch(`${BASE_URL}/support/tickets?${queryParams}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Get single ticket by ID
  getTicket: async (ticketId, token) => {
    const response = await fetch(`${BASE_URL}/support/tickets/${ticketId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Create new ticket
  createTicket: async (ticketData, token) => {
    const response = await fetch(`${BASE_URL}/support/tickets`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(ticketData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Update ticket
  updateTicket: async (ticketId, updateData, token) => {
    const response = await fetch(`${BASE_URL}/support/tickets/${ticketId}`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Get ticket messages
  getTicketMessages: async (ticketId, token) => {
    const response = await fetch(`${BASE_URL}/support/tickets/${ticketId}/messages`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Add message to ticket
  addTicketMessage: async (ticketId, messageData, token) => {
    const response = await fetch(`${BASE_URL}/support/tickets/${ticketId}/messages`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(messageData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Get support categories
  getCategories: async (token) => {
    const response = await fetch(`${BASE_URL}/support/categories`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  // Close ticket
  closeTicket: async (ticketId, token) => {
    return await supportApi.updateTicket(ticketId, { status: 'closed' }, token);
  },

  // Reopen ticket
  reopenTicket: async (ticketId, token) => {
    return await supportApi.updateTicket(ticketId, { status: 'open' }, token);
  }
};